import { HYPERCORE_USDC_ASSET_ID } from "./constants";

export function shouldShowWithdrawTransactions({
	destinationAsset,
	passiveWithdrawTransactions,
}: {
	destinationAsset: string;
	passiveWithdrawTransactions: readonly { txHash: string }[];
}): boolean {
	// Older Hypercore quotes used WITHDRAW for the intermediate hop and
	// PASSIVE_WITHDRAWAL for final delivery. New quotes use WITHDRAW for final delivery.
	return (
		destinationAsset !== HYPERCORE_USDC_ASSET_ID ||
		passiveWithdrawTransactions.length === 0
	);
}

export function isDisplayableTxHash({
	txHash,
	chain,
}: {
	txHash: string | null | undefined;
	chain: string | null | undefined;
}): boolean {
	return chain !== "aleo" || txHash?.startsWith("au1") !== true;
}

export function parseDisplayableTxHashes({
	txHashes,
	chain,
}: {
	txHashes: string | null | undefined;
	chain: string | null | undefined;
}): string[] {
	return (
		txHashes
			?.split(",")
			.filter(Boolean)
			.filter((txHash) => {
				return isDisplayableTxHash({ txHash, chain });
			}) ?? []
	);
}
